import { ProductRequestModel } from './product-request.model';

export class ProductRequestMessage {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  GetProductsRequestMessage!: ProductRequestModel;
}
